// extracted by mini-css-extract-plugin
export var background = "_6w-0";
export var container = "_6w-1";
export var contentItem = "_6w-7";
export var extendedWarranty = "_6w-5";
export var link = "_6w-d";
export var modal = "_6w-b";
export var modalCloseButton = "_6w-9";
export var modalContent = "_6w-3";
export var modalContentMain = "_6w-6";
export var modalImageLogo = "_6w-8";
export var modalLogo = "_6w-a";
export var modalSideImage = "_6w-4";
export var preview = "_6w-c";
export var redoModal = "_6w-2";